<template>
    <div class="app">
      <Header></Header>
        <div class="mid">
<!--            <div style="padding:10px 10px;background: #f8eae2;color:red;font-size:18px;">免费用户接口限制次数和定期清理，请使用专属域名或充值VIP, 用专属域名转换接口。如有疑问，请联系客服。</div>-->
<!--            <div style="height:20px;"></div>-->

           <div class="api-list">
             <h3>API接口列表导航：</h3>
             <a href="#api1"><em class="iconfont icon-dwzmenu"></em> 短网址生成接口</a>
             <a href="#api2"><em class="iconfont icon-dwzmenu"></em> 短网址专属域名生成接口</a>
             <a href="#api3"><em class="iconfont icon-dwzmenu"></em> 短网址更新链接接口(专属域名)</a>
             <a href="#api4"><em class="iconfont icon-dwzmenu"></em> 微信域名检测接口</a>


           </div>

            <h2 class="title">短网址生成接口<a name="api1"></a></h2>
            <ul class="apidoc-content">
                <h3>请求地址</h3>
                <li class="square">https://api.ttdwz.cc/apicreate?token=你的token&url=长链接&mark=备注</li>
                <h3>请求方式</h3>
                <li class="square">GET</li>
                <h3>请求参数（GET）</h3>
                <div class="web-table ovf mt10">
                    <table>
                        <tr>
                            <th class="wd1">字段</th>
                            <th class="wd2">类型</th>
                            <th class="wd3">是否必须</th>
                            <th class="wd4">说明</th>
                            <th class="wd4">示例</th>
                        </tr>
                        <tr>
                            <td class="wd1">token</td>
                            <td class="wd2">string</td>
                            <td class="wd3">必须</td>
                            <td class="wd4">由数字和字母组成的32位字符	</td>
                            <td class="wd4"><router-link class="opt-a" to="/tabs/userToken">获取token</router-link></td>
                        </tr>

                        <tr >
                            <td class="wd1">url</td>
                            <td class="wd2">string</td>
                            <td class="wd3">必须</td>
                            <td class="wd4">长网址,需要进行url编码，否则会丢失长度</td>
                            <td class="wd4">"https://ttdwz.cc"</td>
                        </tr>
                      <tr >
                        <td class="wd1">open_type</td>
                        <td class="wd2">string</td>
                        <td class="wd3">非必须</td>
                        <td class="wd4">打开的类型</td>
                        <td class="wd4">no_weixin=提示浏览器打开</td>
                      </tr>
                        <tr >
                            <td class="wd1">mark</td>
                            <td class="wd2">string</td>
                            <td class="wd3">非必须</td>
                            <td class="wd4">备注</td>
                            <td class="wd4">"天天短网址"</td>
                        </tr>
                    </table>
                </div>
                <h3>请求示例</h3>
                <div class="mt-tabpage">
                    <div class="mt-tabpage-title">
                        <div class="mt-tabpage-item" :class="{'mt-tabpage-item-cur':demoCodeTabs===1}" @click="demoCodeTabs=1">PHP</div>
                        <div class="mt-tabpage-item" :class="{'mt-tabpage-item-cur':demoCodeTabs===2}" @click="demoCodeTabs=2">JavaScript</div>
                    </div>
                    <div class="mt-tabpage-count">
                        <ul class="mt-tabpage-cont__wrap ovf">
                            <li class="mt-tabpage-item" v-show="demoCodeTabs===1">
                                <div class="demo-code overflow-y">
                                  &lt;?php<br>
                                    $long_url='http://aaa.com/?djfjkdjsfj&fkjhjkfhfhf';  //长链接<br>
                                    $long_url=urlencode($long_url);  //进行url编码<br>
                                  $url = ="https://api.ttdwz.cc/apicreate?token=你的token&url=$long_url&mark=备注"<br>
                                  // 创建连接<br>
                                  $result=file_get_contents($url);<br>
                                  // 读取响应<br>
                                  var_dump($result);<br>
                                </div>
                            </li>
                            <li class="mt-tabpage-item" v-show="demoCodeTabs===2">
                                <div class="demo-code overflow-y">
                                    暂无代码
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <h3>响应结果示例</h3>
                <div class="response-result">
                    {<br>
                    &nbsp;&nbsp;&nbsp;"code": 1000,<br>
                    &nbsp;&nbsp;&nbsp;"shortUrl": "https://api.ttdwz.cc",<br>
                    &nbsp;&nbsp;&nbsp;"longUrl": "https://api.ttdwz.cc",<br>
                    &nbsp;&nbsp;&nbsp;"msg": "转换成功",<br>
                    }
                </div>
                <h3>响应参数说明</h3>
                <div class="web-table ovf mt10">
                    <table >
                        <tr>
                            <th class="wd1">字段</th>
                            <th class="wd2">类型</th>
                            <th class="wd4">说明</th>
                        </tr>
                        <tr >
                            <td class="wd1" rowspan="10">code</td>
                            <td class="wd2" rowspan="10">int</td>
                        </tr>
                        <tr class="text-left">
                            <td>1000：转换成功</td>
                        </tr>
                        <tr class="text-left">
                            <td>4001：链接不能为空！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4002：链接格式不正确，需要以http://或https://开头！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4003：请勿重复转换本站短网址！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4004：链接存在风险，请更换后重试，谢谢！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4005：内部错误，请联系客服,QQ:3683390325</td>
                        </tr>
                        <tr class="text-left">
                            <td>4006：请求太频繁(普通用户60/分钟，VIP用户120/分钟)</td>
                        </tr>
                        <tr class="text-left">
                            <td>40008：token验证失败</td>
                        </tr>
                        <tr class="text-left">
                            <td>40009：该链接仅限VIP用户转换</td>
                        </tr>
                        <tr >
                            <td class="wd1">shortUrl</td>
                            <td class="wd2">string</td>
                            <td class="wd3">短网址</td>
                        </tr>
                        <tr >
                            <td class="wd1">longUrl</td>
                            <td class="wd2">string</td>
                            <td class="wd3">长网址（原网址）</td>
                        </tr>
                        <tr >
                            <td class="wd1">msg</td>
                            <td class="wd2">string</td>
                            <td class="wd3">响应消息</td>
                        </tr>
                    </table>
                </div>

            </ul>
        </div>

        <div class="mid">
            <h2 class="title">短网址专属域名生成接口<a name="api2"></a></h2>
            <ul class="apidoc-content">
                <h3>请求地址</h3>
                <li class="square">https://api.ttdwz.cc/exclusiveDomainCreate?token=你的token&url=短网址&domain=专属域名&mark=备注</li>
                <h3>请求方式</h3>
                <li class="square">GET</li>
                <h3>请求参数（GET）</h3>
                <div class="web-table ovf mt10">
                    <table>
                        <tr>
                            <th class="wd1">字段</th>
                            <th class="wd2">类型</th>
                            <th class="wd3">是否必须</th>
                            <th class="wd4">说明</th>
                            <th class="wd4">示例</th>
                        </tr>
                        <tr>
                            <td class="wd1">token</td>
                            <td class="wd2">string</td>
                            <td class="wd3">必须</td>
                            <td class="wd4">由数字和字母组成的32位字符	</td>
                            <td class="wd4"><router-link class="opt-a" to="/tabs/userToken">获取token</router-link></td>
                        </tr>


                        <tr >
                            <td class="wd1">domain</td>
                            <td class="wd2">string</td>
                            <td class="wd3">必须</td>
                            <td class="wd4">专属域名</td>
                            <td class="wd4">"ttdwz.cc"</td>
                        </tr>
                        <tr >
                            <td class="wd1">url</td>
                            <td class="wd2">string</td>
                            <td class="wd3">必须</td>
                            <td class="wd4">长网址</td>
                            <td class="wd4">"https://api.ttdwz.cc"</td>
                        </tr>
                      <tr >
                        <td class="wd1">open_type</td>
                        <td class="wd2">string</td>
                        <td class="wd3">非必须</td>
                        <td class="wd4">打开的类型</td>
                        <td class="wd4">no_weixin=提示浏览器打开</td>
                      </tr>
                        <tr >
                            <td class="wd1">mark</td>
                            <td class="wd2">string</td>
                            <td class="wd3">非必须</td>
                            <td class="wd4">备注</td>
                            <td class="wd4">"天天短网址"</td>
                        </tr>
                    </table>
                </div>
                <h3>请求示例</h3>
                <div class="mt-tabpage">
                    <div class="mt-tabpage-title">
                        <div class="mt-tabpage-item" :class="{'mt-tabpage-item-cur':demoCodeTabs===1}" @click="demoCodeTabs=1">PHP</div>
                        <div class="mt-tabpage-item" :class="{'mt-tabpage-item-cur':demoCodeTabs===2}" @click="demoCodeTabs=2">JavaScript</div>
                    </div>
                    <div class="mt-tabpage-count">
                        <ul class="mt-tabpage-cont__wrap ovf">
                            <li class="mt-tabpage-item" v-show="demoCodeTabs===1">
                                <div class="demo-code overflow-y">
                                  &lt;?php<br>
                                  $url = 'https://api.ttdwz.cc/exclusiveDomainCreate?token=你的token&url=短网址&domain=专属域名&mark=备注'<br>
                                  // 创建连接<br>
                                  $result=file_get_contents($url);<br>
                                  // 读取响应<br>
                                  var_dump($result);<br>
                                </div>
                            </li>
                            <li class="mt-tabpage-item" v-show="demoCodeTabs===2">
                                <div class="demo-code overflow-y">
                                    暂无代码
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <h3>响应结果示例</h3>
                <div class="response-result">
                    {<br>
                    &nbsp;&nbsp;&nbsp;"code": 1000,<br>
                    &nbsp;&nbsp;&nbsp;"shortUrl": "https://api.ttdwz.cc",<br>
                    &nbsp;&nbsp;&nbsp;"longUrl": "https://api.ttdwz.cc",<br>
                    &nbsp;&nbsp;&nbsp;"msg": "转换成功",<br>
                    }
                </div>
                <h3>响应参数说明</h3>
                <div class="web-table ovf mt10">
                    <table >
                        <tr>
                            <th class="wd1">字段</th>
                            <th class="wd2">类型</th>
                            <th class="wd4">说明</th>
                        </tr>
                        <tr >
                            <td class="wd1" rowspan="7">code</td>
                            <td class="wd2" rowspan="7">int</td>
                        </tr>
                        <tr class="text-left">
                            <td>1000：转换成功</td>
                        </tr>
                        <tr class="text-left">
                            <td>4001：链接不能为空！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4002：链接格式不正确，需要以http://或https://开头！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4003：专属域名出错！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4004：专属域名过期！</td>
                        </tr>
                        <tr class="text-left">
                            <td>40008：token验证失败</td>
                        </tr>
                        <tr >
                            <td class="wd1">shortUrl</td>
                            <td class="wd2">string</td>
                            <td class="wd3">短网址</td>
                        </tr>
                        <tr >
                            <td class="wd1">longUrl</td>
                            <td class="wd2">string</td>
                            <td class="wd3">长网址（原网址）</td>
                        </tr>
                        <tr >
                            <td class="wd1">msg</td>
                            <td class="wd2">string</td>
                            <td class="wd3">响应消息</td>
                        </tr>
                    </table>
                </div>

            </ul>
        </div>

        <div class="mid">
            <h2 class="title">短网址更新链接接口(专属域名)<a name="api3"></a></h2>
            <ul class="apidoc-content">
                <h3>请求地址</h3>
                <li class="square">https://api.ttdwz.cc/apiUpdateLink?token=你的token&url=短网址&longurl=长链接&mark=备注</li>
                <h3>请求方式</h3>
                <li class="square">GET</li>
                <h3>请求参数（GET）</h3>
                <div class="web-table ovf mt10">
                    <table>
                        <tr>
                            <th class="wd1">字段</th>
                            <th class="wd2">类型</th>
                            <th class="wd3">是否必须</th>
                            <th class="wd4">说明</th>
                            <th class="wd4">示例</th>
                        </tr>
                        <tr>
                            <td class="wd1">token</td>
                            <td class="wd2">string</td>
                            <td class="wd3">必须</td>
                            <td class="wd4">由数字和字母组成的32位字符	</td>
                            <td class="wd4"><router-link class="opt-a" to="/tabs/userToken">获取token</router-link></td>
                        </tr>


                        <tr >
                            <td class="wd1">url</td>
                            <td class="wd2">string</td>
                            <td class="wd3">必须</td>
                            <td class="wd4">需要更新的长网址</td>
                            <td class="wd4">"https://api.ttdwz.cc"</td>
                        </tr>
                        <tr >
                            <td class="wd1">short_url</td>
                            <td class="wd2">string</td>
                            <td class="wd3">必须</td>
                            <td class="wd4">短网址</td>
                            <td class="wd4">"http://1ikz.cn/FJi31k"</td>
                        </tr>
                        <tr >
                            <td class="wd1">mark</td>
                            <td class="wd2">string</td>
                            <td class="wd3">非必须</td>
                            <td class="wd4">备注</td>
                            <td class="wd4">"天天短网址"</td>
                        </tr>
                    </table>
                </div>
                <h3>请求示例</h3>
                <div class="mt-tabpage">
                    <div class="mt-tabpage-title">
                        <div class="mt-tabpage-item" :class="{'mt-tabpage-item-cur':demoCodeTabs===1}" @click="demoCodeTabs=1">PHP</div>
                        <div class="mt-tabpage-item" :class="{'mt-tabpage-item-cur':demoCodeTabs===2}" @click="demoCodeTabs=2">JavaScript</div>
                    </div>
                    <div class="mt-tabpage-count">
                        <ul class="mt-tabpage-cont__wrap ovf">
                            <li class="mt-tabpage-item" v-show="demoCodeTabs===1">
                                <div class="demo-code overflow-y">
                                  &lt;?php<br>
                                  $url = 'https://api.ttdwz.cc/apiUpdateLink?token=你的token&url=短网址&longurl=长链接&mark=备注'<br>
                                  // 创建连接<br>
                                  $result=file_get_contents($url);<br>
                                  // 读取响应<br>
                                  var_dump($result);<br>
                                </div>
                            </li>
                            <li class="mt-tabpage-item" v-show="demoCodeTabs===2">
                                <div class="demo-code overflow-y">
                                    暂无
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <h3>响应结果示例</h3>
                <div class="response-result">
                    {<br>
                    &nbsp;&nbsp;&nbsp;"code": 1000,<br>
                    &nbsp;&nbsp;&nbsp;"msg": "更新成功",<br>
                    }
                </div>
                <h3>响应参数说明</h3>
                <div class="web-table ovf mt10">
                    <table >
                        <tr>
                            <th class="wd1">字段</th>
                            <th class="wd2">类型</th>
                            <th class="wd4">说明</th>
                        </tr>
                        <tr >
                            <td class="wd1" rowspan="7">code</td>
                            <td class="wd2" rowspan="7">int</td>
                        </tr>
                        <tr class="text-left">
                            <td>1000：转换成功</td>
                        </tr>
                        <tr class="text-left">
                            <td>4001：链接不能为空！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4002：链接格式不正确，需要以http://或https://开头！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4003：专属域名出错！</td>
                        </tr>
                        <tr class="text-left">
                            <td>4004：专属域名过期！</td>
                        </tr>
                        <tr class="text-left">
                            <td>40008：token验证失败</td>
                        </tr>

                        <tr >
                            <td class="wd1">msg</td>
                            <td class="wd2">string</td>
                            <td class="wd3">响应消息</td>
                        </tr>
                    </table>
                </div>

            </ul>
        </div>
      <div class="mid">
        <h2 class="title">微信检测接口<a name="api4"></a></h2>
        <ul class="apidoc-content">
          <h3>请求地址</h3>
          <li class="square">https://api.ttdwz.cc/checkUrl.php?token=你的token&url=https://www.baidu.com/</li>
          <h3>请求方式</h3>
          <li class="square">GET</li>
          <h3>请求参数（GET）</h3>
          <div class="web-table ovf mt10">
            <table>
              <tr>
                <th class="wd1">字段</th>
                <th class="wd2">类型</th>
                <th class="wd3">是否必须</th>
                <th class="wd4">说明</th>
                <th class="wd4">示例</th>
              </tr>
              <tr>
                <td class="wd1">token</td>
                <td class="wd2">string</td>
                <td class="wd3">必须</td>
                <td class="wd4">由数字和字母组成的32位字符	</td>
                <td class="wd4"><router-link class="opt-a" to="/tabs/userToken">获取token</router-link></td>
              </tr>


              <tr >
                <td class="wd1">url</td>
                <td class="wd2">string</td>
                <td class="wd3">必须</td>
                <td class="wd4">需要检测的网址</td>
                <td class="wd4">"https://api.ttdwz.cc"</td>
              </tr>


            </table>
          </div>
          <h3>请求示例</h3>
          <div class="mt-tabpage">
            <div class="mt-tabpage-title">
              <div class="mt-tabpage-item" :class="{'mt-tabpage-item-cur':demoCodeTabs===1}" @click="demoCodeTabs=1">PHP</div>
              <div class="mt-tabpage-item" :class="{'mt-tabpage-item-cur':demoCodeTabs===2}" @click="demoCodeTabs=2">JavaScript</div>
            </div>
            <div class="mt-tabpage-count">
              <ul class="mt-tabpage-cont__wrap ovf">
                <li class="mt-tabpage-item" v-show="demoCodeTabs===1">
                  <div class="demo-code overflow-y">
                    &lt;?php<br>
                    $url = 'https://api.ttdwz.cc/checkUrl?token=你的token&url=需要检测的网址'<br>
                    // 创建连接<br>
                    $result=file_get_contents($url);<br>
                    // 读取响应<br>
                    var_dump($result);<br>
                  </div>
                </li>
                <li class="mt-tabpage-item" v-show="demoCodeTabs===2">
                  <div class="demo-code overflow-y">
                      暂无代码
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <h3>响应结果示例</h3>
          <div class="response-result">
            {  <br>
              "code": 1000,<br>
              "msg": "请求成功",<br>
              "data": {<br>
              "status": 1,<br>
              "url": "http:\/\/www.ttdwz.cc",<br>
              "result": "微信已被拦截"<br>
              }<br>
            }
          </div>
          <h3>响应参数说明</h3>
          <div class="web-table ovf mt10">
            <table >
              <tr>
                <th class="wd1">字段</th>
                <th class="wd2">类型</th>
                <th class="wd4">说明</th>
              </tr>
              <tr >
                <td class="wd1" rowspan="5">code</td>
                <td class="wd2" rowspan="5">int</td>
              </tr>
              <tr class="text-left">
                <td>1000：请求成功</td>
              </tr>
              <tr class="text-left">
                <td>4001：链接不能为空！</td>
              </tr>
              <tr class="text-left">
                <td>4002：链接格式不正确，需要以http://或https://开头！</td>
              </tr>

              <tr class="text-left">
                <td>40008：token验证失败</td>
              </tr>

              <tr >
                <td class="wd1">msg</td>
                <td class="wd2">string</td>
                <td class="wd3">响应消息</td>
              </tr>
              <tr>
                <td class="wd1">data.status</td>
                <td class="wd2">int</td>
                <td class="wd3">1=被拦截,0=正常</td>
              </tr>
            </table>
          </div>

        </ul>
      </div>
        <div class="footer ovf">Copyright &copy; 2018-2020  版权所有</div>
    </div>
</template>

<script>
    import Header from "../header";
    export default {
        name: "ApiDoc",
      components: {Header},
      data() {
            return {
                demoCodeTabs: 1,
                isVip: false,
                isGuest: true,
                user_info: {},
            }
        },
        mounted() {
            const token = this.$storeLocal.get('token');
            const user_info = this.$storeLocal.get('userInfo');
            const times = Date.parse(new Date())/1000;

            if (token !== null && token !== '' && token !== undefined) {
                if (user_info.expire_date > times){
                    this.isVip = true;
                }
                this.isGuest = false;
                this.user_info = user_info;
            }
        }
    }
</script>

<style scoped>
    table{
        border-spacing: 0;
    }
    .app{
        height: auto;
        background-color: #ffffff;
    }
    .mid{
        width: 1200px;
        height: auto;
        margin: 0 auto;
        padding-top: 20px;
    }
    .mid h2.title {
        border-left: 4px solid #008bff;
        height: 20px;
        line-height: 20px;
        padding-left: 5px;
        margin: 10px 0 20px 0;
        font-size: 22px;
        font-weight: 500;
    }
    .apidoc-content {
        list-style: none;
        padding-left: 40px;
    }
    .apidoc-content h3 {
        margin: 20px 0 10px 0;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
        font-size: 18px;
    }
    .apidoc-content li.square {
        list-style: none;
        margin-left: 30px;
        list-style-type: square;
    }
    .web-table {
        text-align: center;
    }
    .web-table a {
        cursor: pointer;
    }
    .web-table table {
        border-bottom: 1px solid #e6e6e6;
        width: 1180px;
        table-layout: fixed;
    }
    .web-table tr th {
        border-top: 1px solid #e6e6e6;
        padding: 16px 5px;
        color: #333;
        vertical-align: middle;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f5f5f5;
        font-weight: normal;
    }
    .web-table tr td {
        border-top: 1px solid #e6e6e6;
        padding: 16px 5px;
        color: #666;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        font-size: 14px;
    }
    .web-table tr:hover td {
        background-color: #f2faff;
    }
    .web-table a.opt-a {
        display: inline-block;
        margin: 0 5px;
        font-size: 14px;
        color: #008df2;
        text-align: center;
    }
    .web-table a.opt-a:hover {
        text-decoration: underline;
    }
    .mt-tabpage {
        width: 1160px;
        background-color: #FFFFFF;
    }
    .mt-tabpage-title {
        height: 44px;
        font-size: 0;
        background-color: #fff;
        width: 100%;
        margin: auto;
        border-bottom: 1px solid #e6e6e6;
    }
    .mt-tabpage-title .mt-tabpage-item {
        display: inline-block;
        width: 105px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        color: #666;
        font-size: 12px;
        list-style: none;
        cursor: pointer;
    }
    .mt-tabpage-title .mt-tabpage-item:hover{
        color: #008df2;
    }
    .mt-tabpage-title .mt-tabpage-item-cur {
        color: #008df2;
        font-size: 14px;
        border-bottom: 1px solid #008df2;
    }
    .mt-tabpage-count {
        position: relative;
        width: 1160px;
        height: 500px;
        overflow: hidden;
        margin-top: 10px;
    }
    .mt-tabpage-cont__wrap {
        position: absolute;
    }
    .mt-tabpage-count .mt-tabpage-item {
        width: 1160px;
        height: 500px;
    }
    .demo-code{
        width: calc(100% - 40px);
        height: calc(100% - 40px);
        background-color: #f5f5f5;
        padding: 20px;
        color: #000000a6;
        font-size: 14px;
        line-height: 30px;
    }
    .demo-code.overflow-y{
        overflow-y: auto;
    }
    .response-result{
        width: calc(100% - 42px);
        min-height: 158px;
        background-color: #f5f5f5;
        border: 1px solid #e6e6e6;
        padding: 20px;
        color: #000000a6;
        font-size: 14px;
        line-height: 30px;
    }
    .ovf{
        overflow: hidden;
    }
    .text-left{
        text-align: left;
    }
    .footer{
        color: #666666;
        text-align: center;
        line-height: 114px;
    }
</style>
